import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useFloorManager } from '../context/FloorManagerContext';
import HeaderShell from './HeaderShell';

const FloorManagerHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useFloorManager();

  const isFloorManagerLoginPage = location.pathname === '/lkart/supervisor-login';
  const showLogoutButton = !isFloorManagerLoginPage;

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
      toast.success('Logged out successfully');
      navigate('/lkart/supervisor-login');
    }
  };

  return (
    <HeaderShell
      showHomeButton={false}
      showBellButton={false}
      showLogoutButton={showLogoutButton}
      onLogoutClick={handleLogout}
    />
  );
};

export default FloorManagerHeader;